<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Health Score'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Empresa</label>
                      <input v-model="dataSearch.companyName" type="text" class="form-control" name="companyName"
                             placeholder="Nome da empresa">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Entrou quantas vezes?</label>
                      <input v-model="dataSearch.hasLogged" v-mask="'###'" type="text" class="form-control"
                             name="hasLogged" placeholder="10">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group multi-select-content">
                      <label>Total de funcionários</label>
                      <div class="inputs-box">
                        <span>De</span>
                        <input v-model="dataSearch.minEmployee" v-mask="'####'" type="text" class="form-control"
                               name="minEmployee" placeholder="0">

                        <span>Até</span>
                        <input v-model="dataSearch.maxEmployee" v-mask="'####'" type="text" class="form-control"
                               name="maxEmployee" placeholder="20">
                      </div>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Não gerou espelho ponto em</label>
                      <input v-model="dataSearch.mirrorLowerThan" v-mask="'###'" type="text" class="form-control"
                             name="mirrorLowerThan" placeholder="10 dias">
                      <span class="mescle-day-input">Dias</span>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Nota abaixo de</label>
                      <input v-model="dataSearch.scoreLowerThan" v-mask="'##'" type="text" class="form-control"
                             name="scoreLowerThan" placeholder="10">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>NPS abaixo de</label>
                      <input v-model="dataSearch.npsLowerThan" v-mask="'##'" type="text" class="form-control"
                             name="npsLowerThan" placeholder="10">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Plano</label>
                      <select v-model="dataSearch.plan" id="plan" name="plan" required>
                        <option value="">Selecione</option>
                        <option value="0">Cliente em Teste</option>
                        <option value="1">Free</option>
                        <option value="2">Plano até 10</option>
                        <option value="3">Plano mais de 10</option>
                        <option value="9">Todos</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Trazer empresas Desativadas?</label>
                      <select v-model="dataSearch.getNotactive" id="getNotactive" name="getNotactive">
                        <option value="false">Não</option>
                        <option value="true">Sim</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="col-xs-12 col-sm-12 col-md-12 item-found">
                  <p>Total encontrado: {{ dataList.length }}</p>
                </div>
                <div v-for="c in dataList" class="col-xs-12 col-sm-4 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 card-company">
                    <div class="title">
                      <h4 v-bind:title="c.companyName">{{ c.companyName | limitTo(55) }}</h4>
                      <small>Total de funcionários: <span>{{ c.totalEmployee }}</span></small>
                    </div>

                    <div class="box-score"
                         v-bind:class="{'warning-score': c.score >= 4 && c.score <= 7, 'success-score': c.score >= 8}">
                      <p>{{ c.score }}</p>
                    </div>

                    <div class="box-info">
                      <p>Plano:
                        <span v-if="c.plan === 0">Cliente em Teste</span>
                        <span v-if="c.plan === 1">Free</span>
                        <span v-if="c.plan === 2">Plano até 10</span>
                        <span v-if="c.plan === 3">Plano mais de 10</span>
                        <span v-if="c.plan === 9">Todos</span>
                        <span v-html="c.plan"></span>
                      </p>
                      <p>Completou configuração inicial:
                        <span v-if="c.completedInitialSettings">Sim</span>
                        <span v-else>Não</span>
                      </p>
                      <p>Email Confirmado?:
                        <span v-if="c.isEmailConfirmed">Sim</span>
                        <span v-else>Não</span>
                      </p>
                      <p>Onbording:
                        <span>
                        <span v-if="c.onBoardingDone">Sim</span>
                        <span v-else>Não</span>
                      </span>
                      </p>
                      <p>NPS Total: <span>{{ c.totalNpsAnswered }}</span></p>
                      <p>Nota:
                        <span>
                        <span v-if="c.npsRating">{{ c.npsRating }}</span>
                        <span v-else>Sem nota</span>
                      </span>
                      </p>
                      <p>Data de cadastro: <span>{{ c.companyCreatedAt }}</span></p>
                    </div>

                    <div class="box-mirror">
                      <small>Espelho</small>

                      <div class="content-progress">
                        <!--                        <div class="progress">-->
                        <!--                          <div v-bind:class="{'w100': c.firstMirrorCreated && c.lastestMirrorCreated}"></div>-->
                        <!--                        </div>-->

                        <div class="progress-round">
                          <div class="round">
                            <p v-tooltip.top-center="formatDateView(c.firstMirrorCreated)" class="round-p"
                               v-bind:class="{'w100': c.firstMirrorCreated}"></p>
                            <p>Primeiro</p>
                          </div>
                          <div class="round">
                            <p v-tooltip.top-center="formatDateView(c.lastestMirrorCreated)" class="round-p"
                               v-bind:class="{'w100': c.lastestMirrorCreated}"></p>
                            <p>Último</p>
                          </div>
                        </div>
                      </div>

                      <p class="text">{{ c.difFromMirrors }}</p>
                    </div>

                    <div class="box-access">
                      <small>Acessos</small>
                      <div class="content-progress">
                        <!--                        <div class="progress">-->
                        <!--                          <div v-bind:class="{'w50': c.firstAccessPanel && c.secondAccessPanel && !c.thirdAccessPanel, 'w100': c.firstAccessPanel && c.secondAccessPanel && c.thirdAccessPanel}"></div>-->
                        <!--                        </div>-->
                        <div class="progress-round">
                          <div class="round">
                            <p v-tooltip.top-center="formatDateView(c.firstAccessPanel)" class="round-p"
                               v-bind:class="{'w100': c.firstAccessPanel}"></p>
                            <p>Primeiro</p>
                          </div>
                          <div class="round">
                            <p v-tooltip.top-center="formatDateView(c.secondAccessPanel)" class="round-p"
                               v-bind:class="{'w100': c.secondAccessPanel}"></p>
                            <p>Segundo</p>
                          </div>
                          <div class="round">
                            <p v-tooltip.top-center="formatDateView(c.thirdAccessPanel)" class="round-p"
                               v-bind:class="{'w100': c.thirdAccessPanel}"></p>
                            <p>Terceiro</p>
                          </div>
                        </div>

                      </div>
                    </div>

                    <p class="p-link"><a v-bind:href="'/detalhe-health-score/' + c.companyId + '/' + c.contextCode"
                                         target="_blank" class="link">Ver Detalhes</a></p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  HEALTH_SCORE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import moment from "moment";

export default {
  name: "health-score",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      dataSearch: {
        plan: "",
        companyName: "",
        minEmployee: "",
        maxEmployee: "",
        scoreLowerThan: "",
        npsLowerThan: "",
        hasLogged: "",
        mirrorLowerThan: "",
        getNotactive: false
      },
      failRequest: false,
      loadingList: false,
      dataList: []
    }
  },
  methods: {
    formatDateView(value) {
      if (value)
        return moment(String(value)).format('DD/MM/YYYY hh:mm');
      else
        return '';
    },
    getList() {
      if (!this.loadingList) {
        this.loadingList = true;
        let url = HEALTH_SCORE;
        url += "?u=" + JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id;

        if (this.dataSearch.companyName)
          url += "&companyName=" + this.dataSearch.companyName;

        if (this.dataSearch.minEmployee)
          url += "&minEmployee=" + this.dataSearch.minEmployee;

        if (this.dataSearch.maxEmployee)
          url += "&maxEmployee=" + this.dataSearch.maxEmployee;

        if (this.dataSearch.scoreLowerThan)
          url += "&scoreLowerThan=" + this.dataSearch.scoreLowerThan;

        if (this.dataSearch.npsLowerThan)
          url += "&npsLowerThan=" + this.dataSearch.npsLowerThan;

        if (this.dataSearch.hasLogged)
          url += "&hasLogged=" + this.dataSearch.hasLogged;

        if (this.dataSearch.mirrorLowerThan)
          url += "&mirrorLowerThan=" + this.dataSearch.mirrorLowerThan;

        if (this.dataSearch.getNotactive)
          url += "&getNotactive=" + this.dataSearch.getNotactive;

        if (this.dataSearch.plan)
          url += "&plan=" + this.dataSearch.plan;

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT HEALTH_SCORE:", response.data);

          this.dataList = response.data;
          this.loadingList = false;
          this.failRequest = false;
        }).catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      }
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style lang="scss">
.item-found {
  p {
    margin-top: 0;
    font-size: 18px;
    font-weight: 500;
  }
}

.mescle-day-input {
  position: absolute;
  top: 25px;
  right: 14px;
  width: 43px;
  background: #727980;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 5px 0 !important;
}

.multi-select-content {
  .inputs-box {
    span {
      display: inline-block;
      width: 7%;
      color: #a59797;
    }

    input {
      display: inline-block;
      width: calc(100% - 60%);
    }
  }
}

.card-company {
  border: 1px solid #a3a6a9;
  border-radius: 4px !important;
  padding: 14px 20px;
  position: relative;
  margin-bottom: 30px;
  min-height: 810px;

  a {
    color: unset;

    &:hover {
      text-decoration: none;
    }
  }

  .title {
    min-height: 70px;

    h4 {
      margin-bottom: 0;
      width: 85%;
      line-height: 25px;
    }

    small {
      font-size: 80%;
      margin-top: 5px;
      display: block;

      span {
        font-weight: bold;
        font-size: 12px;
      }
    }
  }

  .box-score {
    position: absolute;
    right: 25px;
    border-radius: 100% !important;
    border: 2px solid red;
    width: 50px;
    text-align: center;
    height: 50px;
    line-height: 29px;
    top: 20px;

    p {
      position: relative;
      top: -10px;
      font-size: 20px;
      font-weight: 500;
      color: red;
    }
  }

  .warning-score {
    border: 2px solid orange;

    p {
      color: orange;
    }
  }

  .success-score {
    border: 2px solid green;

    p {
      color: green;
    }
  }

  .box-info {
    margin-top: 30px;

    p {
      margin: 0 0 7px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e6e9ec;

      span {
        font-weight: 600;
      }
    }
  }

  .box-access,
  .box-mirror {
    margin-top: 30px;
    border: 1px dashed #a3a6a9;
    padding: 14px 20px;
    border-radius: 4px !important;

    .content-progress {
      margin-top: 10px;

      .progress {
        border-radius: 4px !important;

        div {
          background: red;
          height: 100%;
          width: 5%;
        }

        .w50 {
          background: orange;
          width: 50%;
        }

        .w100 {
          background: green;
          width: 100%;
        }
      }

      .progress-round {
        text-align: center;

        .round {
          display: inline-block;
          margin: 10px 5% 0;

          .round-p {
            width: 34px;
            height: 34px;
            background: #bababa;
            border-radius: 100px !important;
            display: block;
            margin: 0 auto;
          }

          p {
          }
        }

        .w50 {
          background: orange !important;
        }

        .w100 {
          background: green !important;
        }

      }

      .stages {
        p {
          display: inline-block;
        }
      }
    }

    .text {
      margin: 0;
      text-decoration: initial;
      font-size: 12px;
    }

  }

  .p-link {
    margin: 0;
    text-align: right;
    margin-top: 20px;
  }

  .link {
    color: #3598dc;
    border-bottom: 1px solid #3598dc;
    cursor: pointer;

    &:hover,
    &:focus,
    &:active {
      font-weight: 600;
      text-decoration: none;
      color: #054F91;
      border-bottom: 1px dashed #054F91;
    }
  }

}

// Tooltip
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/healtScore/healthScore.vue